








































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import UpdateProductIssueRequest from '@/models/Products/ProductIssues/UpdateProductIssueRequest';

@Component({ name: 'ProductIssueEditDialog' })
export default class extends SaascadaVueDialog {

    request: UpdateProductIssueRequest = new UpdateProductIssueRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
        //this.request = new UpdateProductIssueRequest();
        //this.request.onSale = ProductIssueDetailsModule.productIssue.onSale;
        //this.request.updatedAt = ProductIssueDetailsModule.productIssue.updatedAt;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductIssueDetailsModule.editProductIssue(this.request);
            await ProductIssueDetailsModule.getHistory();
        }
    }

}
